export default function showMessage(
    message,
    enqueueSnackbar,
    type = 'success',
) {
    const messageStr = Array.isArray(message) ? message.join(', ') : message;
    const messageType = type === 'success' ? 'success' : 'error';
    enqueueSnackbar(messageStr, { variant: messageType });
}
